import { render, staticRenderFns } from "./CreateViewForm.vue?vue&type=template&id=6702ee42&scoped=true"
import script from "./CreateViewForm.vue?vue&type=script&lang=js"
export * from "./CreateViewForm.vue?vue&type=script&lang=js"
import style0 from "./CreateViewForm.vue?vue&type=style&index=0&id=6702ee42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6702ee42",
  null
  
)

export default component.exports